import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisation OrganisationModel
 * @param email string
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisation, email) {
    var headers = { 'Content-Type': 'application/json' };
    var url = applyPathVariables(EndPoints.ORGANISATION_USERS_INVITE, { organisationId: organisation.id });
    var request = new Request({
        method: Methods.POST,
        url: url,
        withCredentials: true,
        headers: headers,
        data: JSON.stringify(email)
    });
    return request.execute();
});
